import AUPostCollectionsRepository from './AUPostCollectionsStoreRepository';

export default AUPostCollectionsRepository;
